import Image from 'next/image'

import Breadcrumbs from '@/molecules/Breadcrumb/Breadcrumb'

interface Props {
  title: string
  description?: string
  heroBgColor: string
  heroTextColor: string
  stats: {
    title: string
    description: string
  }[]
  featuredImage: StrapiImageFile
  customerLogo: StrapiImageFile
}

function IndividualCaseStudyPageHero({
  title,
  description,
  heroBgColor,
  heroTextColor,
  stats,
  featuredImage,
  customerLogo
}: Props) {
  const breadcrumbs: Breadcrumb[] = [
    { name: 'Home', url: '/' },
    { name: 'Customers', url: '/case-study/' },
    { name: title, url: '' }
  ]

  return (
    <section className="font-heading text-white">
      <nav
        aria-label="breadcrumbs"
        className="flex justify-center | mx-auto py-4 px-4 md:pt-10 md:pb-0 xl:px-0"
        style={{ background: heroBgColor, color: heroTextColor }}
      >
        <Breadcrumbs breadcrumbItems={breadcrumbs} />
      </nav>
      <div
        className="pt-10 pb-7 md:pt-20 md:pb-28"
        style={{ background: heroBgColor }}
      >
        <div className="container | relative z-20">
          <div className="max-w-col-6" style={{ color: heroTextColor }}>
            {customerLogo?.url && (
              <Image
                src={customerLogo.url}
                alt={customerLogo.alternativeText ?? ''}
                height={customerLogo.height}
                width={customerLogo.width}
                className="h-10 w-auto |  mb-9 lg:mb-12"
                priority
              />
            )}
            <h1 className="text-2xl md:text-3xl font-semibold | mb-3 md:mb-4 md:h-44">
              {title}
            </h1>
            <p className="text-sm md:text-base mb-10 md:mb-5">{description}</p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 | mb-10 md:h-20">
              {stats.map(item => (
                <div key={item.title} style={{ color: heroTextColor }}>
                  <div
                    className="text-4xl font-medium tracking-wider uppercase | mb-2"
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                  <div
                    className="font-body text-xs | max-w-xs"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="text-white | max-w-col-10">
            {featuredImage?.url && (
              <Image
                src={featuredImage.url}
                alt={featuredImage.alternativeText ?? ''}
                height={featuredImage.height}
                width={featuredImage.width}
                className="rounded-2xl relative lg:absolute lg:top-0 lg:-right-32 lg:overflow-hidden lg:max-w-2xl z-20 shadow-md"
                priority
              />
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default IndividualCaseStudyPageHero
